var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41.658,
    height: 41.658,
    viewBox: "0 0 41.658 41.658",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        opacity: 0.6;\n      }\n\n      .cls-2 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.293,
    cy: 1.077,
    r: 1.325,
    gradientTransform: "translate(0 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.097,
    stopColor: "#ffd87a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.143,
    stopColor: "#fcce78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#f5b471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338,
    stopColor: "#eb8d65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449,
    stopColor: "#e36058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#cd3694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6668b0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-instagram",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    className: "cls-2",
    d: "M41.658,32.147a9.507,9.507,0,0,1-9.511,9.511H9.511A9.507,9.507,0,0,1,0,32.147V9.52A9.521,9.521,0,0,1,9.52,0H32a9.653,9.653,0,0,1,9.658,9.658Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(5.736 5.744)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    className: "cls-3",
    d: "M91.386,70.6H79.8a9.3,9.3,0,0,0-9.3,9.3V91.478a9.29,9.29,0,0,0,9.3,9.292H91.378a9.289,9.289,0,0,0,9.292-9.292V79.9A9.278,9.278,0,0,0,91.386,70.6Zm6.4,19.763a7.507,7.507,0,0,1-7.51,7.51H80.915a7.507,7.507,0,0,1-7.51-7.51V81.006a7.507,7.507,0,0,1,7.51-7.51h9.357a7.513,7.513,0,0,1,7.51,7.51Z",
    transform: "translate(-70.5 -70.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-3",
    d: "M171.249,159a7.949,7.949,0,1,0,7.949,7.949A7.945,7.945,0,0,0,171.249,159Zm0,12.725a4.784,4.784,0,1,1,4.784-4.784A4.782,4.782,0,0,1,171.249,171.725Z",
    transform: "translate(-155.749 -151.807)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    className: "cls-3",
    d: "M331.136,134.626a2.018,2.018,0,1,1-2.018-2.026A2.017,2.017,0,0,1,331.136,134.626Z",
    transform: "translate(-306.222 -127.555)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon-instagram.23d551d1ed63b70aeed28e2129443dbc.svg";
export { ForwardRef as ReactComponent };